<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link class="Header_menu__logo Header_menu__logo--sm" to="">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
        <div class="Heade__main">
          <div class="Header__menu_area Header__step_area">
            <div class="Step__box">
              <div class="Step__head">
                Step
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle Step__circle--active ft_en">
                  <span>1</span>
                </div>
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en">
                  <span>2</span>
                </div>
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en">
                  <span>3</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="contents contents--pt">
      <section class="Form _min-h _min-h-sp">
        <div class="inner">
          <h1 class="Form__head Form__head--mb_md">
            MELON ONLINEご登録フォーム
          </h1>
          <div class="Form__area">
            <div
              :class="`Form__input_box Form__input_box--mb_md Form__input_box--md ${getStatus($v.form.last_name)}`"
            >
              <div class="Form__input_heda Form__input_head_required Form__input_head_required_tx_box">
                姓<span
                  class="Form__input_head_required_tx"
                >*必須</span>
              </div>
              <input
                v-model.trim="$v.form.last_name.$model"
                class="Form__input"
                type="text"
                placeholder="山田"
                required
              >
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.form.last_name.required">姓を入力してください</label>
                  <label v-if="!$v.form.last_name.maxLength">姓の最大長255</label>
                </div>
              </div>
            </div>
            <div :class="`Form__input_box Form__input_box--mb_md Form__input_box--md ${getStatus($v.form.first_name)}`">
              <div class="Form__input_heda Form__input_head_required">
                名
              </div>
              <input v-model.trim="$v.form.first_name.$model" class="Form__input" type="text" placeholder="太郎">
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.form.first_name.required">名を入力してください</label>
                  <label v-if="!$v.form.first_name.maxLength">名を入力の最大長255</label>
                </div>
              </div>
            </div>
            <div :class="`Form__input_box Form__input_box--md ${getStatus($v.form.phone) || getStatus($v.form.phone1) || getStatus($v.form.phone2) || getStatus($v.form.phone3)}`">
              <div class="Form__input_heda Form__input_head_required">
                電話番号
              </div>
              <div class="Form-group-custom">
                <input
                  v-model="$v.form.phone1.$model"
                  class="Form__input Form__input_number"
                  placeholder="079"
                  type="number"
                  inputmode="decimal"
                  pattern="\\d*"
                  @keypress="onlyNumber"
                  @input="updatePhoneNumber"
                >
                <label class="number-seperate">-</label>
                <input
                  v-model="$v.form.phone2.$model"
                  class="Form__input Form__input_number"
                  placeholder="1234"
                  inputmode="decimal"
                  pattern="\\d*"
                  type="number"
                  @keypress="onlyNumber"
                  @input="updatePhoneNumber"
                >
                <label class="number-seperate">-</label>
                <input
                  v-model="$v.form.phone3.$model"
                  class="Form__input Form__input_number"
                  placeholder="5678"
                  inputmode="decimal"
                  pattern="\\d*"
                  type="number"
                  @keypress="onlyNumber"
                  @input="updatePhoneNumber"
                >
              </div>
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.form.phone1.required || !$v.form.phone2.required || !$v.form.phone3.required">電話番号を入力してください</label>
                  <label v-if="isPhoneFullInput() && (!$v.form.phone.maxLength || !$v.form.phone.minLength)">10~15文字で設定してください</label>
                </div>
              </div>
            </div>
            <button
              class="Btn__blue Form__btn Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg"
              @click.prevent="nextStep()"
            >
              次へ進む
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import SignUpLayout from '@/views/layouts/SignUpLayout'
import { mapState } from 'vuex'
import checkNumber from '@/helpers/onlyNumber'
import { redirect } from '@/helpers'
import authService from '@/services/authService'

const touchMap = new WeakMap()
const validations = {
  form: {
    first_name: {
      required,
      maxLength: maxLength(255)
    },
    last_name: {
      required,
      maxLength: maxLength(255)
    },
    phone: {
      required,
      maxLength: maxLength(17),
      minLength: minLength(12)
    },
    phone1: {
      required
    },
    phone2: {
      required
    },
    phone3: {
      required
    }
  }
}
export default {
  name: 'RegisterStep1',
  layout: SignUpLayout,
  mixins: [validationMixin],
  validations: validations,
  data() {
    return {}
  },
  computed: {
    ...mapState({
      form: state => state.auth.signUpData
    })
  },
  mounted() {
    this.getDataStep1()
  },
  methods: {
    async getDataStep1() {
      if (localStorage.getItem('step1')) {
        const dataStep1 = localStorage.getItem('step1')
        this.form.first_name = JSON.parse(dataStep1).first_name
        this.form.last_name = JSON.parse(dataStep1).last_name
        this.form.phone = JSON.parse(dataStep1).phone
        if (this.form.phone.includes('-')) {
          this.form.phone1 = this.form.phone.split('-')[0]
          this.form.phone2 = this.form.phone.split('-')[1]
          this.form.phone3 = this.form.phone.split('-')[2]
        } else {
          this.form.phone1 = this.form.phone.substring(0, 3)
          this.form.phone2 = this.form.phone.substring(3, 7)
          this.form.phone3 = this.form.phone.substring(7, this.form.phone.length)
        }
      }
      if (Object.keys(this.$router.currentRoute.query).length !== 0) {
        if (this.$router.currentRoute.query.email) {
          this.form.email = this.$router.currentRoute.query.email

          if (this.$router.currentRoute.query.company_id) {
            this.form.company_id = this.$router.currentRoute.query.company_id
          } else {
            this.form.company_id = null
          }

          if (this.$router.currentRoute.query.user_introduce) {
            this.form.user_introduce = this.$router.currentRoute.query.user_introduce
          } else {
            this.form.user_introduce = 0
          }

          if (this.$router.currentRoute.query.utm_source) {
            this.form.utm_source = this.$router.currentRoute.query.utm_source
          } else {
            this.form.utm_source = null
          }

          if (this.$router.currentRoute.query.utm_medium) {
            this.form.utm_medium = this.$router.currentRoute.query.utm_medium
          } else {
            this.form.utm_medium = null
          }

          if (this.$router.currentRoute.query.utm_campaign) {
            this.form.utm_campaign = this.$router.currentRoute.query.utm_campaign
          } else {
            this.form.utm_campaign = null
          }

          if (this.$router.currentRoute.query.utm_coupon) {
            this.form.utm_coupon = this.$router.currentRoute.query.utm_coupon
            await authService.verifyCoupon(this.form.utm_coupon).then((response) => {
              if (response.data.retrieve.valid === false || response.success === false) {
                alert('クーポンの期限が切れました')
                this.couponError = true
              } else {
                this.form.coupon_name = response.data.retrieve.name
              }
            }).catch(() => {
              alert('クーポンの期限が切れました')
              const redirectPath = '/signin'
              redirect(redirectPath)
              this.couponError = true
            })
          } else {
            this.form.utm_coupon = null
          }

          if (this.$router.currentRoute.query.register) {
            this.form.register = this.$router.currentRoute.query.register
          } else {
            this.form.register = null
          }
          this.$store.dispatch('auth/nextStep', this.form)
        } else {
          window.location.href = '/corpwelfare-member-register'
        }
      } else {
        window.location.href = '/corpwelfare-member-register'
      }
      authService.checkEmailStatus(this.form).then(() => {
      }).catch(() => {
        alert('メールアドレスは既に登録されています。')
        redirect('/signin')
      })
    },
    onlyNumber($event) {
      checkNumber.onlyNumber($event)
    },
    delayTouch($v) {
      $v.$reset()
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set($v, setTimeout($v.$touch, 1000))
    },
    updatePhoneNumber() {
      this.form.phone = [this.form.phone1, this.form.phone2, this.form.phone3].join('-')
      if (this.isPhoneFullInput()) {
        this.delayTouch(this.$v.form.phone)
      }
    },
    isPhoneFullInput() {
      return this.form.phone1 && this.form.phone2 && this.form.phone3
    },
    getStatus(validation) {
      return validation.$error ? '_error' : ''
    },
    pad(d) {
      return (d < 10) ? '0' + d.toString() : d.toString()
    },
    nextStep() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$store.dispatch('auth/nextStep', this.form)
        if (this.form.user_type === 'corp-trial') {
          this.$router.push('/corp-trial-member-register/step-2')
        } else {
          this.$router.push('/corpwelfare-member-register/step-2')
        }
      }
    }
  }

}
</script>
